import React from 'react';

const CensusTractLegendItem = ({ legendColor, legendText }) => {
  const styles = {
    minRect: {
      fill: legendColor,
      stroke: 'black',
      strokeWidth: '1px'
    },
    midRect: {
      fill: legendColor,
      stroke: 'black',
      strokeWidth: '1px',
    },
    maxRect: {
      fill: legendColor,
      stroke: 'black',
      strokeWidth: '1px',
    },
    legendTextSpan: {
      marginLeft: '3px',
    }
  }
  return (
    <div>
      <svg width={8} height={8}>
        <rect width={8} height={8} x={0} y={0} style={styles.minRect}></rect>
      </svg>
      <span style={styles.legendTextSpan}>
        {legendText}
      </span>
    </div>
  )
}

export default CensusTractLegendItem;